import {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import moment from 'moment';
import {filter, isArray, orderBy} from 'lodash';
import {setSnackbar} from '../../../../../store/reducers/globals';
import API from '../../../../../app/api';

/**
 * @param {string} hospitalNumber Patient's hospital number.
 * @param {string} hospitalId Search to specific hospital id.
 * @param {string} startDate Search from date, format "DD-MM-YYYY".
 * @param {string} endDate Search to date, format "DD-MM-YYYY".
 * @param {boolean} allPatient Search all patient slots between dates.
 */
export default function usePatientAppointments({ hospitalNumber, startDate = null, hospitalId = null, endDate = null, allPatients = false }) {
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [patientAppointments, setPatientAppointments] = useState([]);

    useEffect(() => {
        const fetchData = async (ptId, hospId, start, end) => {
            setIsLoading(true);

            try {
                let filterStr = `${ptId && !allPatients ? `patientId=${ptId}` : ''}`;

                if (hospId) {
                    if (!filterStr) filterStr += `hospitalId=${hospId}`
                    else filterStr += `&hospitalId=${hospId}`
                }

                const apiResponse = await API.getAppointmentSlots(
                    moment(start ? start : '01-03-2025', 'DD-MM-YYYY'),
                    moment(end ? end : '01-03-2045', 'DD-MM-YYYY'),
                    false,
                    filterStr,
                );

                if (isArray(apiResponse)) {
                    const filtered = allPatients ? apiResponse : filter(apiResponse,{ patientId: ptId });
                    const sorted = orderBy(filtered, ['startDate'], ['desc']);

                    setPatientAppointments(sorted);
                }
            } catch (err) {
                dispatch(setSnackbar({type: 'error', message: "Error getting patient's appointments."}))
            } finally {
                setIsLoading(false);
            }
        };

        if (hospitalNumber || allPatients) {
            fetchData(hospitalNumber, hospitalId, startDate, endDate);
        }
    }, [hospitalNumber, hospitalId, startDate, endDate, allPatients]);

    return [patientAppointments, isLoading];
}